import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import EndSidebar from "../EndSidebar";
import { useDispatch } from "react-redux";
import { fetchBalance, fetchSipUserData } from "../../slices/walletSlice";
import { SIPProvider } from "../../helper/sipProvider";
import { BASE_DOMAIN, DecryptToken, VOIP_WS_URL } from "../../helper/Constants";
import SIPAdminHandler from "../SIPAdminHandler";

const Layout = (props) => {
  const dispatch = useDispatch();
  const [openNav, setOpenNav] = useState(false);
  const userToken = localStorage.getItem("psx_token");
  const decodedToken = DecryptToken(userToken);
  const OpenNavHandler = () => {
    setOpenNav(!openNav);
  };

  useEffect(() => {
    const body = document.querySelector("body");
    body.classList.toggle("toggle-sidebar", openNav);
    return () => body.classList.remove("toggle-sidebar");
  }, [openNav]);

  useEffect(() => {
    dispatch(fetchBalance());
    dispatch(fetchSipUserData());
  }, [dispatch]);

  return (
    <>
      <SIPProvider options={{
        domain: BASE_DOMAIN,
        webSocketServer: VOIP_WS_URL,
        register: true,
        registerExpires: 300,
        allowLegacyNotifications: true
      }}>

        {decodedToken?.user_id ? (
          <Header openNav={openNav} navHandler={OpenNavHandler} user_id={decodedToken?.user_id} />
        ) : (
          ""
        )}
        <Sidebar openNav={openNav} navHandler={OpenNavHandler} />
        <EndSidebar openNav={openNav} navHandler={OpenNavHandler} />

        <SIPAdminHandler/>

        <main className="min-h-screen w-full max-w-full min-w-0 overflow-x-hidden bg-zinc-50 px-4 pb-16 pt-20 text-zinc-900 transition-all duration-300 sm:px-6 lg:ml-64 lg:w-[calc(100%-16rem)] lg:px-8 dark:bg-black dark:text-zinc-100">
          <div className="w-full max-w-full min-w-0">
            {props.children}
          </div>
        </main>
      </SIPProvider>
    </>
  );
};

export default Layout;
